export default __webpack_public_path__ + "static/media/bg_important_notice.51deb088.webp";